/* provider-auth-required-svg.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./provider-auth-required-svg.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
import { ProviderAuthRequiredSVGOld } from './provider-auth-required-svg-old';
var imageStyles = null;
export var ProviderAuthRequiredSVGNew = function ProviderAuthRequiredSVGNew() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "170",
    height: "130",
    viewBox: "0 0 170 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: ax(["_1bsbuuw1 _4t3i11ux _otyrpxbi"])
  }, /*#__PURE__*/React.createElement("rect", {
    width: "170",
    height: "130",
    rx: "6.25",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.75 2H6.25C3.90279 2 2 3.90279 2 6.25V123.75C2 126.097 3.90279 128 6.25 128H163.75C166.097 128 168 126.097 168 123.75V6.25C168 3.90279 166.097 2 163.75 2ZM6.25 0C2.79822 0 0 2.79822 0 6.25V123.75C0 127.202 2.79822 130 6.25 130H163.75C167.202 130 170 127.202 170 123.75V6.25C170 2.79822 167.202 0 163.75 0H6.25Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 14H2V12H168V14Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 43L2 43L2 41L168 41V43Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 72H2V70H168V72Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 128L28 2H30L30 128H28Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 128L98 2H100L100 128H98Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "34",
    y: "24.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "104",
    y: "24.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "34",
    y: "53.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "104",
    y: "53.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "34",
    y: "111.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "104",
    y: "111.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "34",
    y: "82.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "104",
    y: "82.5",
    width: "60",
    height: "6",
    rx: "3",
    fill: "#091E42",
    fillOpacity: "0.06"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.5",
    x: "8",
    y: "20.5",
    width: "14",
    height: "14",
    rx: "2",
    fill: "#1D7AFC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.5",
    x: "8",
    y: "49.5",
    width: "14",
    height: "14",
    rx: "2",
    fill: "#1D7AFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 101H2V99H168V101Z",
    fill: "#091E42",
    fillOpacity: "0.14"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.5",
    x: "8",
    y: "107.5",
    width: "14",
    height: "14",
    rx: "2",
    fill: "#1D7AFC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: "0.5",
    x: "8",
    y: "78.5",
    width: "14",
    height: "14",
    rx: "2",
    fill: "#1D7AFC"
  }));
};
export var ProviderAuthRequiredSVG = function ProviderAuthRequiredSVG() {
  if (fg('bandicoots-compiled-migration-link-datasource')) {
    return /*#__PURE__*/React.createElement(ProviderAuthRequiredSVGNew, null);
  } else {
    return /*#__PURE__*/React.createElement(ProviderAuthRequiredSVGOld, null);
  }
};